<template>
  <div>
    <!-- <v-btn v-if="$route.name === 'Riparian'" dark color="#e059a6" href="#">
      <span class="font-weight-light mr-2"
        >Create a Restoration Project</span
      ></v-btn
    > -->
    <v-btn flat href="http://riparianresourcesab.info">
      <v-icon>info</v-icon>&nbsp;<span class="font-weight-light mr-2"
        >Information</span
      >
    </v-btn>
    <v-btn flat @click="$router.push({ name: 'Riparian' })">
      <v-icon>explore</v-icon>&nbsp;<span class="font-weight-light mr-2"
        >Riparian Map Data</span
      >
    </v-btn>
    <v-btn flat @click="$emit('show-contact-overlay')">
      <v-icon>alternate_email</v-icon>&nbsp;<span class="font-weight-light mr-2"
        >Contact</span
      >
    </v-btn>
    <v-btn flat @click="$emit('show-tac-overlay')">
      <v-icon>policy</v-icon>&nbsp;<span class="font-weight-light mr-2"
        >Terms of Use</span
      >
    </v-btn>

    <v-menu v-if="authenticated && authAsMenu" offset-y>
      <v-btn flat slot="activator">
        <v-icon>fingerprint</v-icon>&nbsp;<span class="font-weight-light mr-2"
          >Auth</span
        >
      </v-btn>
      <v-list>
        <v-list-tile @click="$emit('sign-out')">
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="changeAuthModal(true)"
          v-if="adminUsers.includes(user.username)"
        >
          <v-list-tile-title>Add User</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="showUsers()"
          v-if="adminUsers.includes(user.username)"
        >
          <v-list-tile-title>List Users</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <div v-else-if="authenticated">
      <v-btn flat @click="$emit('sign-out')">
        <v-icon>fingerprint</v-icon>&nbsp;<span class="font-weight-light mr-2"
          >Logout</span
        >
      </v-btn>
      <v-btn
        flat
        @click="changeAuthModal(true)"
        v-if="adminUsers.includes(user.username)"
      >
        <v-icon>account_circle</v-icon>&nbsp;<span
          class="font-weight-light mr-2"
          >Add User</span
        >
      </v-btn>
    </div>

    <v-btn v-else flat @click="changeAuthModal(true)">
      <v-icon>fingerprint</v-icon>&nbsp;<span class="font-weight-light mr-2"
        >Login</span
      >
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "NavButtons",

  props: {
    authAsMenu: { type: Boolean, default: true },
  },

  computed: {
    adminUsers() {
      return this.$store.state.settings.adminUsers;
    },
    authenticated() {
      return this.$store.state.settings.authenticated;
    },
    user() {
      return this.$store.state.settings.user;
    },
  },

  methods: {
    changeAuthModal(value) {
      this.$store.commit("settings/toggleAuthModal", value);
    },
    showUsers() {
      this.$router.push({ name: "Users" });
    },
  },
};
</script>

<style scoped>
</style>
